const DEFAULT_DEV_API_BASE_URL = 'http://localhost:4000/api/v1';
const DEFAULT_PROD_API_BASE_URL = 'https://api.ludolio.com/api/v1';

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? DEFAULT_DEV_API_BASE_URL : DEFAULT_PROD_API_BASE_URL);